<script lang="ts">
  import type { Snippet } from 'svelte';

  type Props = {
    onClick?: () => void;
    href?: string;
    outlink?: boolean;
    children: Snippet;
  };
  const props: Props = $props();
</script>

{#if props.onClick}
  <button onclick={props.onClick} class="link">
    <span>
      {@render props.children()}
    </span>
  </button>
{:else if props.href}
  <a
    href={props.href}
    class="link"
    target={props.outlink ? '_blank' : undefined}
    rel={props.outlink ? 'noreferrer' : undefined}
  >
    <span>
      {@render props.children()}
    </span>
  </a>
{/if}

<style lang="scss">
  @use '~/theme/themify' as *;
  @use '~/theme/include-media' as *;
  .link {
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px 8px;
    border-radius: 0;
    text-decoration: none;
    @include themify {
      color: themed('link');
    }
    span {
      border-bottom: 2px solid currentColor;
      display: flex;
      align-items: center;
      @include media('<=450px') {
        font-size: 0.8rem;
      }
    }
    :global(svg) {
      width: 1em;
      height: 1em;
      margin-left: 0.5em;
      margin-right: 0.25em;
    }
  }
</style>
